/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Cookies from "js-cookie";

import ReservationForm from "./components/ReservationForm";
import Header from "./components/Header";
import Notification from "./components/Notification";

import { useAuth } from "./contexts/AuthContext";

import Login from "./pages/Login";

import "./App.css";
import RoomTypes from "./pages/RoomTypes";
import Fork from "./pages/Fork";
import CrewPopulated from "./pages/CrewPopulated";
import Wep from "./pages/Wep";
import Uc from "./pages/Uc";
import ConversationsDashboard from "./pages/ConversationsDashboard";
import FreeDrinkCoupon from "./pages/FreeDrinkCoupon";
import SchedulesListPage from "./pages/scheduler/SchedulesListPage";
import UpsellSchedulePage from "./pages/scheduler/UpsellSchedulePage";

function App() {
  const token = Cookies.get("jwtToken");

  const { login, logout } = useAuth();

  useEffect(() => {
    if (token) login();
    else logout();
  }, []);

  return (
    <>
      <Header />
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/app" component={Fork}/>
        <Route path="/crew/reservations" component={CrewPopulated} />
        <Route path="/upsell/reservation" component={ReservationForm} />
        <Route exact path="/upsell/schedules" component={SchedulesListPage} />
        <Route exact path="/upsell/schedules/new" component={UpsellSchedulePage} />
        <Route path="/upsell/schedules/:id/edit" component={UpsellSchedulePage} />
        {/* <Route
          exact
          path="/upsell/schedules/new"
          render={(routeProps) => (
            <UpsellScheduleManager initialSchedule={null} {...routeProps} />
          )}
        />
        <Route
          path="/upsell/schedules/:id/edit"
          render={(routeProps) => (
            <UpsellScheduleManager
              initialSchedule={routeProps.location?.state?.schedule}
              {...routeProps}
            />
          )}
        /> */}
        <Route path="/upsell/room-types" component={RoomTypes} />
        <Route path="/wep" component={Wep}/>
        <Route path="/uc" component={Uc}/>
        <Route path="/email-conversations" component={ConversationsDashboard}/>
        <Route path="/freedrinkcoupon/:sha" component={FreeDrinkCoupon}/>
      </Switch>
      <Notification />
    </>
  );
}

export default App;
